import getRenderStatus from './render-status';

export default {
  getRenderStatus,
};
